<template>
    <Box  @close="cerrar(false)" v-if="producto_venta">
        <template #top>Modificar Producto Venta</template>
        <template #center>
            <div class="nj-card">
                <div class="nj-cols c2">
                    <div>
                        <div class="nj-label">Tipo Producto (N1)</div>
                        <select class="nj-select" v-model="producto_venta.pti_id_parent" @change="seleccionarNivel2()" disabled>
                            <option></option>
                            <option v-for="item in producto_venta_tipos_n1" :key="item.pti_id" :value="item.pti_id">{{ item.pti_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Tipo Producto (N2)</div>
                        <select class="nj-select" v-model="producto_venta.pti_id" disabled>
                            <option></option>
                            <option v-for="item in producto_venta_tipos_n2" :key="item.pti_id" :value="item.pti_id">{{ item.pti_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Grupo</div>
                        <select class="nj-select" v-model="producto_venta.pvt_grupo">
                            <option></option>
                            <option v-for="item in producto_venta_grupos" :key="item.id" :value="item.id">{{ item.nombre }}</option>
                        </select>
                    </div>
                </div>
                <div class="nj-cols c2">
                    <div>
                        <div class="nj-label">Marcas</div>
                        <select class="nj-select" v-model="producto_venta.mar_id" disabled>
                            <option></option>
                            <option v-for="item in marcas" :key="item.mar_id" :value="item.mar_id">{{ item.mar_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Unidad medida</div>
                        <select class="nj-select" v-model="producto_venta.unm_id" disabled>
                            <option></option>
                            <option v-for="item in unidades_medida" :key="item.unm_id" :value="item.unm_id">{{ item.unm_simbolo }}</option>
                        </select>
                    </div>
                </div>
                <div>
                    <div class="nj-label">Nombre</div>
                    <input type="text" class="nj-text" v-model="producto_venta.pvt_nombre" disabled>
                </div>
                <div>
                    <div class="nj-label">Descripcion</div>
                    <textarea class="nj-text" rows="5" v-model="producto_venta.pvt_descripcion" disabled></textarea>
                </div>
                <div class="nj-cols c4">
                    <div>
                        <div class="nj-label">Precio minimo</div>
                        <input type="text" class="nj-text" v-model="producto_venta.pvt_precio_minimo" disabled>
                    </div>
                    <div>
                        <div class="nj-label">Precio venta</div>
                        <input type="text" class="nj-text" v-model="producto_venta.pvt_precio" disabled>
                    </div>
                    <div>
                        <div class="nj-label">Precio con IGV</div>
                        <input type="text" class="nj-text" v-model="pvt_precio_igv" disabled>
                    </div>
                    <div>
                        <div class="nj-label">Stock</div>
                        <input type="text" class="nj-text" v-model="producto_venta.pvt_stock" disabled>
                    </div>
                </div>
            </div>
        </template>
    </Box>
</template>

<script>
import { AppService, ResponseStatus } from "../../rest"
import ProductoVentaService from "../../services/ProductoVentaService"
import ProductoVentaTipoService from "../../services/ProductoVentaTipoService"
import Toast from "../../util/toast"
import { Box } from "../components"

export default {
    name: "VerProductoVenta",
    components: {
        Box
    },
    data() {
        return {
            producto_venta: null,
            marcas: [],
            unidades_medida: [],
            producto_venta_grupos: [],
            producto_venta_tipos_n1: [],
            producto_venta_tipos_n2: [],
        }
    },
    props: {
        pvt_id: {
            type: Number
        }
    },
    computed: {
        pvt_precio_igv() {
            return Math.round(this.producto_venta.pvt_precio * 1.18 * 100) / 100
        }
    },
    methods: {
        seleccionarNivel2() {
            this.producto_venta_tipos_n2 = []
            if (this.producto_venta.pti_id_parent) {
                ProductoVentaTipoService.buscar({
                    producto_venta_tipo: {
                        pti_parent: this.producto_venta.pti_id_parent
                    }
                }).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.producto_venta_tipos_n2 = response.data
                        }
                        else {
                            Toast.warn(response.message)
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
        },
        cerrar(condition) {
            this.$emit("close", condition)
        },
    },
    mounted() {
        AppService.getData(["marcas", "unidades_medida", "producto_venta_tipos", "producto_venta_grupos"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.marcas = response.data.marcas
                    this.unidades_medida = response.data.unidades_medida
                    this.producto_venta_tipos_n1 = response.data.producto_venta_tipos
                    this.producto_venta_grupos = response.data.producto_venta_grupos
                    // buscando el producto-venta
                    ProductoVentaService.obtener({
                        producto_venta: {
                            pvt_id: this.pvt_id
                        }
                    }).then(
                        response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.producto_venta = response.data
                                this.seleccionarNivel2()
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>